import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { StoreListPage } from '@/features/store'

export const Route = createFileRoute('/_authenticated/_main/loja/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Loja') }]
  }),
  component: StoreListPage
})
